import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'
import returnsServices from '@/returns/services/services'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'

const useMarkAsIssued = ({ orderId, setToastInfo }) => {
  const [showMarkAsIssuedModal, setShowMarkAsIssuedModal] = useState(false)

  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)

  const { fetchData: markAsIssued, loading: markingAsIssued } = useFetch(returnsServices.markAsIssued, {
    doInitialRequest: false,
  })

  const handleMarkAsIssued = async (notes, issueReason) => {
    const payload = {
      notes,
      reason: issueReason,
    }

    try {
      const response = await markAsIssued({ orderId, payload })

      setShowMarkAsIssuedModal(false)
      setPendingWebsocketAction(pendingWebsocketActionTypes.markAsIssued, response)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const openMarkAsIssuedModal = () => {
    setShowMarkAsIssuedModal(true)
  }

  const closeMarkAsIssuedModal = () => {
    setShowMarkAsIssuedModal(false)
  }

  return {
    showMarkAsIssuedModal,
    setShowMarkAsIssuedModal,
    handleMarkAsIssued,
    markingAsIssued,
    openMarkAsIssuedModal,
    closeMarkAsIssuedModal,
  }
}

export default useMarkAsIssued
